import React from 'react'
import ContactForm from '../UI/contactForm'
import * as styles from './contact.module.css'

const Contact = () => {
  return (
    <section>
      <div className={styles.contact} id="contact">
        <div className={styles.contactInner}>
          <span>Нужен веб-сайт?</span>
          <h2>Хотите заказать новый веб-сайт?</h2>
          <p>
            Заполните форму и мы свяжемся с Вами в кратчайшее время и обсудим
            все детали.
          </p>
          <p>
            Мы учтем Ваши пожелния по дизайну, структуре и наполнению и создадим
            современный, красивый и эффективный веб-сайт для Вашего бизнеса.
          </p>
          <div className={styles.contactInfo}>
            <ul>
              <li>Телефон: </li>
              <li>Email: </li>
              <li>Часы работы:</li>
            </ul>
            <ul>
              <li>+7 (982) 324-16-84</li>
              <li>support@frudee.ru</li>
              <li>Пн-Пт 09:00 - 20:00</li>
            </ul>
          </div>
        </div>
        <ContactForm />
      </div>
    </section>
  )
}

export default Contact
